import Web3 from 'web3';
import hostABI from '../web3/hostContract.json';
import helperContract from '../web3/helperContract.json';
import userContract from '../web3/userContract.json';
import contactContract from '../web3/contactContract.json';
import calendarContract from '../web3/calendarContract.json';
import config from '../web3/web3Config.json';
import Cookies from "universal-cookie";
import { contactDB } from '../db/db-helper';
import { contractCall } from './web3helper';
import { reportError, toErrorString } from '../utils/errorLogger';

const cookies = new Cookies();
const web3 = new Web3(config?.CHAIN_DETAILS?.rpcUrls[0]);

export const getHostContract = (isWss = false) => {
    try {
        const hostContractMethod = contractCall(hostABI.contract, config.CONTRACT, isWss);
        return hostContractMethod;
    } catch (err) {
        console.log(err);
    }
}
export const getUserContract = () => {
    try {
        const hostContractMethod = contractCall(userContract.contract, config.USER_REGISTRY_CONTRACT);
        return hostContractMethod;
    } catch (err) {
        console.log(err);
    }
}

export const getHostHelperContract = () => {
    try {
        const helperContractMethod = contractCall(helperContract.contract, config.HELPER);
        return helperContractMethod;
    } catch (err) {
        console.log(err);
    }
}

export const getContactContract = () => {
    try {
        const contactContractMethod = contractCall(contactContract.contract, config.CONTACT_CONTRACT);
        return contactContractMethod;
    } catch (err) {
        console.log(err);
    }
}

export const getCalendarContract = () => {
    try {
        const calendarContractMethod = contractCall(calendarContract.contract, config.CALENDAR_CONTRACT);
        return calendarContractMethod;
    } catch (err) {
        console.log(err);
    }
}

export const getUserDetails = () => {
    try {
        const user = cookies.get("userObject");
        return user;
    } catch (error) {
        const userName = localStorage.getItem('UserName');
        const errorStr = toErrorString(error || error.message);
        reportError({
            endpoint: '-',
            message: `FileName: contractHelper.js, Fun: getUserDetails, ${String(error.message || 'Unhandled error')}`,
            error: errorStr,
            userName: userName || '',
            level: 'warn',
        });
        return null;
    }
}

export const getSuggestion = async () => {
    try {
        const hostContract = getHostContract();
        const helperContract = getHostHelperContract();
        const calendarContract = getCalendarContract();
        const user = getUserDetails();
        const addressBookForUser = await hostContract.methods.getAddressBookForUser(user.name).call();
        const web2AddressBookForUser = await helperContract.methods.getWeb2Emails(user.name).call();
        const getCalendarContacts = await calendarContract.methods.getContacts(user.name).call();
        const filteredCalendarContacts = getCalendarContacts
            .filter(item => item.key === "contact")
            .map(item => item.value);
        const contactList = await contactDB.contacts.get("contactList")
        const finalResponse = contactList?.data && contactList?.data?.length > 0 ? contactList?.data : []
        const formattedContacts = finalResponse.filter((contact) =>
            !contact.attributes.some((attr) => attr.key === 'isDeleted' && attr.value === 'true')
        ).flatMap(contact => contact.email);
        const filteredAddressBook = addressBookForUser.concat(web2AddressBookForUser, formattedContacts, filteredCalendarContacts)
            .filter((email) => email !== "")
            .reduce((uniqueEmails, email) => {
                if (!uniqueEmails.includes(email)) {
                    uniqueEmails.push(email);
                }
                return uniqueEmails;
            }, []).sort((a, b) => a.localeCompare(b));
        return filteredAddressBook;
    } catch (err) {
        console.log(err);
    }
}